import React from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'antd';
import PropertyFormFragment from '../forms/PropertyForm';
import VariableForm from '../forms/VariableForm';
import WhatsappButton from '../WhatsappButton';
import PropTypes from 'prop-types';

const PropertyStep = () => {

  return (
    <React.Fragment>
      <Row justify="center">
        <Col xs={24} md={22} lg={18} xl={14}>
          <PropertyFormFragment id="property_data" />
          <VariableForm id="contract_variables" />
        </Col>
        <WhatsappButton />
      </Row>
    </React.Fragment>
  );
};

PropertyStep.propTypes = {
  form: PropTypes.object,
};

export default connect()(PropertyStep);